import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/home-view.vue'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/about-item.vue')
    },
    {
      path: '/store',
      name: 'store',
      component: () => import('./views/store-view.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/contact-item.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/admin/AdminHome.vue')
    },
    {
      path: '/admin/manage-item', // /:itemNumber*',
      name: 'addEditItem',
      component: () => import('./views/admin/AddEditItem.vue'), // TODO -- this route takes precedent over confirmation...
      props: true,
      children: [] // todo -- wanted to have the route /admin/manage-item/confirmation, but couldn't get the route to match properly
    },
    {
      path: '/admin/confirmation',
      name: 'addConfirmation',
      component: () => import('./views/admin/CreateSuccess.vue')
    },
  ]
})
